import { EnumBasedItem, createEnumService } from "./base";

export enum CourseStatusType {
  ACTIVE = "active",
  CLOSED = "closed",
  CANCELLED = "cancelled",
}

export class CourseStatus extends EnumBasedItem<CourseStatusType> {}

const courseStatusService = createEnumService(CourseStatusType, CourseStatus);
export default courseStatusService;
